import React from 'react'
import Notification from '../components/Notification'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { removeNotificationAction } from '../actions/Actions'

class NotificationBox extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      top: props.headerHeight + 20
    }
  }

  onScroll = () => {
    const { headerHeight } = this.props
    const scrollTop = window.pageYOffset || document.body.scrollTop

    let top = headerHeight - scrollTop
    top = (top < 0 ? 0 : top) + 20
    this.setState({
      top
    })
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }

  render() {
    const { notifications, dismiss } = this.props
    return (
      <div className="position-relative">

        <div className="notifications-block" style={{
          top: this.state.top + 'px'
        }}>
          {Object.keys(notifications)
                 .map(id => <Notification
                   message={notifications[id].message}
                   id={id}
                   key={id}
                   dismiss={dismiss}
                   error={notifications[id].error}
                 />)}
        </div>
      </div>
    )
  }

}

export default connect(
  (state) => ({
    notifications: state.notifications
  }),
  (dispatch) => ({
    dismiss: bindActionCreators(removeNotificationAction, dispatch)
  })
)(NotificationBox)